import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { formatPrice } from '@weft/services';
import type { Currency } from '@weft/types';
import React from 'react';

const styles = StyleSheet.create({
  rows: {
    borderBottomWidth: '1px',
    borderBottomColor: '#E8F2F8',
    padding: '12px 17px',
    rowGap: '10px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '12px',
    color: '#292D32',
  },
  amountDueContainer: {
    borderBottomWidth: '1px',
    borderBottomColor: '#E8F2F8',
    borderTopWidth: '1px',
    borderTopColor: '#E8F2F8',
    display: 'flex',
    flexDirection: 'row',
    padding: '12px 26px',
    color: '#292D32',
    fontSize: '14px',
    fontWeight: 700,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

type SubtotalProps = {
  total: number;
  currency: Currency;
};

export const Subtotal: React.FC<SubtotalProps> = ({ total, currency }) => {
  return (
    <View
      wrap={false}
      style={{ marginTop: 'auto' }}
    >
      <View style={styles.amountDueContainer}>
        <Text>Amount Due</Text>
        <Text>
          {formatPrice(total, currency)}
        </Text>
      </View>
    </View>
  );
};